import { DefaultService } from '@/services/DefaultService';

export default class MotivoRegistroService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, page, limit, situacao, params) {
        return this._http.get( encodeURI(`${this._env}/agro/motivoregistro.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/motivoregistro/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
        this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(form) {
        return this._http.post(`${this._env}/agro/motivoregistro`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}